// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export class ChartMathCoefficients {
    private _multipleCoefficient = 1;

    get MultipleCoefficient (): number {
        return this._multipleCoefficient;
    }

    set MultipleCoefficient (value) {
        this._multipleCoefficient = value;
    }

    public getCoefficientFont (font): any {
        return font;
    }

    public getCoefficientPen (pen): any {
        return pen;
    }
}
